export default "__VITE_ASSET__BJMLKQss__"